//--------------- IMPORTAÇÕES ---------------//
import { createContext, useState } from "react";



//--------------- CRIAÇÃO DO CONTEXTO DE PRODUTOS ---------------//
export const ProdutosContext = createContext();



//--------------- EXPORTAÇÃO DO PROVIDER DO CONTEXTO DE PRODUTOS ---------------//
export const ProdutosProvider = ({ children }) => {



    //--------------- CRIAÇÃO DOS HOOKS ---------------//
    const [products, setProducts] = useState([]); // Estado que armazena a lista de Produtos existentes
    const [formData, setFormData] = useState({ nome: "", id_produto_hotmart: "" }); // Estado que armazena o Objeto Formulário
    const [isOpenModalCreateProduct, setIsOpenModalCreateProduct] = useState(false); // Estado que armazena se o Modal de criação de Produto está aberto ou não
    const [isOpenModalEditProduct, setIsOpenModalEditProduct] = useState(false); // Estado que armazena se o Modal de edição de Produto está aberto ou não
    const [formDataModalCreateProduct, setFormDataModalCreateProduct] = useState({ nome: "", id_produto_hotmart: "", id_produto_kiwify: "", id_produto_lastlink: "", descricao: "", conhecimento_extra: "" }); // Estado que armazena o Objeto Formulário do Modal de criação de Produto
    const [formDataModalEditProduct, setFormDataModalEditProduct] = useState({ id: "", nome: "", id_produto_hotmart: "", id_produto_kiwify: "", id_produto_lastlink: "", descricao: "", conhecimento_extra: "" }); // Estado que armazena o Objeto Formulário do Modal de edição de Produto

    

    //--------------- RETORNO DO PROVIDER ---------------//
    return (
        <ProdutosContext.Provider value={{
            products, setProducts, formData, setFormData, isOpenModalCreateProduct, setIsOpenModalCreateProduct, isOpenModalEditProduct,
            setIsOpenModalEditProduct, formDataModalCreateProduct, setFormDataModalCreateProduct, formDataModalEditProduct, setFormDataModalEditProduct
        }}>
            {children}
        </ProdutosContext.Provider>
    );



};